const context = require.context('./', true, /\.css$/); // Match all .css files
context.keys().forEach(context); // Import all the CSS files
